<template>
  <el-select filterable v-bind="$attrs" v-on="$listeners">
    <el-option
      v-for="item in arrs"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
      <span class="label">{{ item.label }}</span>
      <span class="img"><img :src="selectTag" /></span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "hm-select",
  data() {
    return {
      selectTag: require("../../assets/images/main/selectTag.svg"),
    };
  },
  props: {
    arrs: Array,
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped lang='less'>
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: none;
}
.el-select-dropdown__item.selected {
  background: #1d63fd;
  color: #fff;
  font-weight: normal;
}
.img {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/baseComponents/hm-select.vue